import { ElementRef, EventEmitter, Input, Output, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepicker, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { QueovalDate, QueovalDateRange } from '../../models';
import { CoreService, CustomDatepickerI18n, I18n, QueovalDateService } from '../../services';

@Component({
  selector: 'datepicker-range',
  templateUrl: './datepicker-range.component.html',
  styleUrls: ['./datepicker-range.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class DatepickerRangeComponent {


  constructor(private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private qDateService: QueovalDateService,) {
  }

  hoveredDate: NgbDate | null = null;

  @Output('DateRange') emitter: EventEmitter<QueovalDateRange> = new EventEmitter<QueovalDateRange>();

  @Input('DateDebut')
  set _fromDate(value: QueovalDate) {
    if (this.qDateService.IsNull(value)) {
      this.fromDate = null;
    } else {
      this.fromDate = new NgbDate(parseInt(value.annee, 10), parseInt(value.mois, 10), parseInt(value.jour, 10));
    }
  }
  @Input('DateFin')
  set _toDate(value: QueovalDate) {
    if (this.qDateService.IsNull(value)) {
      this.toDate = null;
    } else {
      this.toDate = new NgbDate(parseInt(value.annee, 10), parseInt(value.mois, 10), parseInt(value.jour, 10));
    }
  }

  @ViewChild('datepicker') Datepicker: any;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  target: string;

  onDateSelection(date: NgbDate) {
    let closeDt: boolean = true;
    if (this.target == 'FROM') {
      if (this.toDate && date.after(this.toDate)) {
        this.fromDate = this.toDate;
        this.toDate = date;
      } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
        this.toDate = date;
      } else if (this.fromDate && date.equals(this.fromDate)) {
        this.toDate = date;
      } else {
        closeDt = Boolean(this.fromDate).valueOf();
        this.fromDate = date;
      }
    }


    if (this.target == 'TO') {
      if (this.fromDate && date.before(this.fromDate)) {
        this.toDate = this.fromDate;
        this.fromDate = date;
      } else if (this.toDate && !this.fromDate && date.before(this.toDate)) {
        this.fromDate = date;
      } else if (this.toDate && date.equals(this.toDate)) {
        this.fromDate = date;
      } else {
        closeDt = Boolean(this.toDate).valueOf();
        this.toDate = date;
      }
    }

    this.emitDate(closeDt);
  }



  isHovered(date: NgbDate) {
    if (!this.hoveredDate) {
      return this.isInside(date)
    }

    return (this.target == 'FROM' && ((this.fromDate && this.hoveredDate?.before(this.toDate) && date.after(this.hoveredDate) && date.before(this.toDate)) ||
      (this.fromDate && this.hoveredDate?.after(this.toDate) && date.before(this.hoveredDate) && date.after(this.toDate)) ||
      (this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)))) ||

      (this.target == 'TO' && ((this.toDate && this.hoveredDate?.after(this.fromDate) && date.before(this.hoveredDate) && date.after(this.fromDate)) ||
        (this.toDate && this.hoveredDate?.before(this.fromDate) && date.after(this.hoveredDate) && date.before(this.fromDate)) ||
        (this.toDate && !this.fromDate && this.hoveredDate && date.before(this.toDate) && date.after(this.hoveredDate))));
  }

  isInside(date: NgbDate) { return this.toDate && date.after(this.fromDate) && date.before(this.toDate); }


  isRangeLocked(date: NgbDate) {
    if (this.target == 'FROM') {
      return date.equals(this.toDate);
    }

    if (this.target == 'TO') {
      return date.equals(this.fromDate);
    }
    return false;
  }

  isRange(date: NgbDate) {
    if (!this.hoveredDate) {
      return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date);
    }

    if (this.target == 'FROM') {
      return date.equals(this.toDate);
    }

    if (this.target == 'TO') {
      return date.equals(this.fromDate);
    }



    return false;
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) ||
      this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }


  deleteDate(event: MouseEvent) {
    event.stopPropagation();
    if (this.target == 'FROM') {
      this.fromDate = null;
    } else {
      this.toDate = null;
    }
    this.emitDate(true);
  }

  emitDate(closeDt: boolean) {
    if (closeDt) {
      this.Datepicker.close();
      this.hoveredDate = null;
    }

    const dateRange = new QueovalDateRange();
    dateRange.from = new QueovalDate(this.fromDate?.year.toString(), this.fromDate?.month.toString(), this.fromDate?.day.toString());
    dateRange.to = new QueovalDate(this.toDate?.year.toString(), this.toDate?.month.toString(), this.toDate?.day.toString());
    this.emitter.emit(dateRange);
  }
}
function veiwchild(arg0: string) {
  throw new Error('Function not implemented.');
}





@Pipe({
  name: 'ngbDate'
})
export class NgbDatePipe implements PipeTransform {

  constructor(
    protected indParam: CoreService,
  ) { }

  transform(value: NgbDateStruct | null): string {

    if (value == undefined) {
      return 'JJ/MM/AAAA';
    } else {
      const date: Date = new Date(`${value.year}-${value.month}-${value.day}`);
      return new Intl.DateTimeFormat(this.indParam.AppParams.culture).format(date);
    }
  }
}
